module.exports = __webpack_public_path__ + "static/media/214-Sturz-Milo_ID_2.ec767db4.mp3";